import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Setup from "@/pages/Setup";
import Dashboard from "@/pages/Dashboard";
import Tasks from "@/pages/Tasks";
import Calendar from "@/pages/Calendar";
import Billing from "@/pages/Billing";
import Clients from "@/pages/Clients";
import Users from "@/pages/Users";
import MyTasks from "@/pages/MyTasks";
import AuditLog from "@/pages/AuditLog";
import Profile from "@/pages/Profile";
import "@/App.css";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/setup" element={<Setup />} />

                        <Route
                            element={
                                <ProtectedRoute>
                                    <Layout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<Dashboard />} />
                            <Route path="/tasks" element={<Tasks />} />
                            <Route path="/calendar" element={<Calendar />} />
                            <Route path="/billing" element={<Billing />} />
                            <Route path="/clients" element={<Clients />} />
                            <Route
                                path="/users"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <Users />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/my-tasks"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <MyTasks />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/audit"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <AuditLog />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/profile" element={<Profile />} />
                        </Route>

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    <Toaster
                        position="top-right"
                        richColors
                        toastOptions={{
                            classNames: {
                                toast:
                                    "border border-border bg-white text-foreground shadow-sm",
                            },
                        }}
                    />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
